import cn from 'classnames'
import {FC} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {CheckCircleIcon} from '@/components/common/icons/CheckCircleIcon'
import {useTranslation} from '@/i18n'
import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type PricingIncludedBenefitsProps = {
  benefitsTitle: string
  benefits: string[]
  fullWidth?: boolean
}

export const PricingIncludedBenefits: FC<React.PropsWithChildren<PricingIncludedBenefitsProps>> = ({
  benefitsTitle,
  benefits,
  fullWidth,
}) => {
  const {t} = useTranslation()

  return (
    <>
      <div className={cn('benefits', fullWidth && 'full-width')}>
        <Text variant={TextVariant.h5} element="h3" fontWeight={TextFontWeight.bold}>
          {benefitsTitle}
        </Text>
        <ul className="list">
          {benefits.map((item) => (
            <li key={item} className="item">
              <div className="checkmark">
                <CheckCircleIcon size={IconSize.small} />
              </div>
              <Text>{t(item)}</Text>
            </li>
          ))}
        </ul>
      </div>

      <style jsx>{`
        .benefits {
          flex: 1;
          padding: ${theme.spacing[6]};
          background-color: ${theme.palette.background.butter};
          border-radius: 16px;
        }
        .list {
          display: flex;
          flex-wrap: wrap;
          margin-top: ${theme.spacing[2]};
        }
        .item {
          display: flex;
          flex: 1 0 100%;
          margin-top: ${theme.spacing[3]};
        }
        .checkmark {
          margin-top: ${theme.spacing[1]};
          margin-right: ${theme.spacing[3]};
        }
        .full-width {
          margin-left: ${theme.spacing[6]};
          margin-right: ${theme.spacing[6]};
          border-top-left-radius: 0;
          border-top-right-radius: 0;
        }
        .full-width .item {
          flex: 1 0 45%;
        }
        @media ${TABLET_SCREENSIZE} {
          .benefits,
          .full-width {
            margin-left: ${theme.spacing[6]};
            margin-right: ${theme.spacing[6]};
            border-top-left-radius: 0;
            border-top-right-radius: 0;
          }
          .item,
          .full-width .item {
            flex: 1 0 345px;
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .benefits {
            padding: ${theme.spacing[4]};
          }
          .item {
            margin-top: ${theme.spacing[2]};
          }
          .benefits,
          .full-width {
            margin-left: 0;
            margin-right: 0;
          }
          .item,
          .full-width .item {
            flex: 1 0 100%;
          }
        }
      `}</style>
    </>
  )
}
